export default __webpack_public_path__ + "static/media/10.da3771f5.png";